import React from 'react';
import '../styles/Home.css';

function Home() {
  return (
    <div className="home-container">
      <div className="home-content">
        <h1 className="india-text">INDIA</h1>
      </div>
    </div>
  );
}

export default Home;
